// extracted by mini-css-extract-plugin
module.exports = {"message":"styles_message__15n58","content":"styles_content__4jteF","text":"styles_text__2Rhg2","grid":"styles_grid__1PZiq"};